import { Button } from '@mantine/core';
import { variants } from '@uag/react-core';
import { useShallow } from 'zustand/shallow';

import { SettingView } from 'app/modules/wallforming/components/setting-container/types/settingView';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const SettingNavigator = () => {
    const { selectedSettingView, setSelectedSettingView } = usePlacementStore(
        useShallow((state) => ({
            selectedSettingView: state.selectedSettingView,
            setSelectedSettingView: state.setSelectedSettingView
        }))
    );

    return (
        <>
            {Object.values(SettingView).map((label, index) => (
                <Button
                    key={`${label}-${index}`}
                    className={`
                            min-w-28 flex justify-center h-10
                            data-[selected=true]:bg-background-action-hover
                            data-[selected=false]:bg-background-default
                        `}
                    data-selected={selectedSettingView === label}
                    name={label}
                    style={{ fontSize: '0.8rem' }}
                    tabIndex={-1}
                    variant={variants.button.secondary}
                    onClick={() => {
                        setSelectedSettingView(label);
                    }}
                >
                    {label}
                </Button>
            ))}
        </>
    );
};
